<section class="authorized">
    <div class="text-center">
        <img src="assets/images/warn.svg" alt="finger-click-image" />
        <h1 mat-dialog-title class="mb-2">{{ 'authorizedTitle' | translate }}</h1>
    </div>
    <div mat-dialog-content>
        {{ 'authorizedDesc' | translate }}
    </div>
    <div mat-dialog-actions>
        <button mat-button class="btn btn-coral w-100" (click)="onUserConfirm()">{{ 'authorizedBtn' | translate }}</button>
    </div>
</section>
